import React from "react";
import FindTest from "../FindTest"; // Re-use the FindTest component

function UserTestReport() {
  // This component simply acts as a wrapper for the FindTest component,
  // allowing us to give it a unique route and place it in the reports section.
  // We can add more report-specific UI or logic here in the future if needed.
  return <FindTest />;
}

export default UserTestReport;
